<ion-header mode="md" class="ion-no-border">
  <!-- ? Header Titulo -->
  <ion-toolbar mode="md" color="darkblue" class="toolbar">
    <!-- Back -->
    <ng-container *ngIf="hasButtonBack">
      <ion-button
        class="mpe-button-icon-circle ion-no-padding"
        size="default"
        mode="ios"
        shape="round"
        fill="clear"
        color="darkblue"
        slot="start"
        (click)="backEvent()"
      >
        <ion-icon name="previus-white"></ion-icon>
      </ion-button>
    </ng-container>

    <!-- Titulo -->
    <ion-label mode="md" color="white" class="title">
      {{ "Titles.my-profile" | translate }}
    </ion-label>
  </ion-toolbar>

  <!-- ? Datos principales del usuario -->
  <ion-grid fixed class="ion-text-center grid-content">
    <ion-row class="ion-align-items-center">
      <!-- * NUD -->
      <ion-col size="4" class="nud-bodega">
        <ion-label mode="md" color="status-icon-enable" class="title-slot" [attr.data-test]="'Automation.txt-profile-nrocliente' | translate">
          {{ "Labels.client-number" | translate }}
          <p class="number-slot">
            <ion-text color="tpcta">
              {{ pricipalUser.NUD }}
            </ion-text>
          </p>
        </ion-label>
      </ion-col>

      <!-- * Icono  y Teléfono -->
      <ion-col size="4" class="ion-no-padding">
        <div class="circle-avatar">
          <img [src]="'Icons.profile-user-icon' | translate" />
        </div>

        <ion-label mode="md" color="tpcta" class="number-slot" [attr.data-test]="'Automation.txt-profile-telefono' | translate">
          {{ pricipalUser.Telefono }}
        </ion-label>
      </ion-col>

      <!-- * Bodega -->
      <ion-col size="4" class="nud-bodega">
        <ion-label mode="md" color="status-icon-enable" class="title-slot" [attr.data-test]="'Automation.txt-profile-nrobodega' | translate">
          {{ "Labels.warehouse-number" | translate }}
          <p class="number-slot">
            <ion-text color="tpcta">
              {{ pricipalUser.ID_Bodega }}
            </ion-text>
          </p>
        </ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-header>
